import * as React from 'react';
import styles from './styles.module.css';
import { ZoneDetail } from '../../../types/device';
import { statusIconMap, statusStyleMap } from './LineHeroCard';

interface Props {
    isSelected?: boolean;
    isDisabled?: boolean;
    data: ZoneDetail;
    click: (record: any) => void
}

const ZoneHeroCard: React.FunctionComponent<Props> = (props) => {

    const { data, click, isSelected = false, isDisabled = false } = props;
    const icon = statusIconMap[data.bitStatus?.[0]];

    const classes = [
        styles.zoneHeroCard,
        isSelected ? styles.selected : '',
        isDisabled ? styles.disabled : '',
        statusStyleMap[data.bitStatus?.[0]] || ''
    ].filter(Boolean).join(' ');

    return (
        <div
            className={classes}
            onClick={() => {
                if (!isDisabled) {
                    click(data);
                }
            }}
        >
            <div className={styles.statusCircle}>
                <h4 className={styles.statusCount}>{data.id}</h4>
                {icon && React.cloneElement(icon as React.ReactElement, { className: styles.statusIcon })}
            </div>
        </div>
    );
};

export default ZoneHeroCard;
